import { render, staticRenderFns } from "./Personalization.vue?vue&type=template&id=e29a9832&scoped=true"
import script from "./Personalization.vue?vue&type=script&lang=js"
export * from "./Personalization.vue?vue&type=script&lang=js"
import style0 from "./Personalization.vue?vue&type=style&index=0&id=e29a9832&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e29a9832",
  null
  
)

export default component.exports